import React, { useState } from 'react';
import Modal from '../../../components/Modal';
import PropTypes from 'prop-types';
import CastleLogo from '../../../../src/assets/images/Logo_Castle 1.png';
import { useUpdateAssignmentPrintMessageMutation } from '../../../features/authentication/persistApiSlice';
import HelpRequest from '../../dashboard/components/Modals/HelpRequest';
import appConfig from '../../../app-config';

const AssignmentPrintMessage = ({
  isOpen,
  onClose
}) => {
  const baseUrl = appConfig.apiBaseUrl;
  const [hidePrintInfo, setHidePrintInfo] = useState(false);
  const [openFeedbackModel, setOpenFeedbackModel] = useState(false);
  const [updatePrintMessage] = useUpdateAssignmentPrintMessageMutation();

  const updatePrintMessageAsync = async (isChecked) => {
    const option = {
      hidePrintMessage: isChecked
    };
    await updatePrintMessage(option).unwrap();
    setHidePrintInfo(isChecked);
  };

  return (
    <>
      <Modal
        contentWidth='700px'
        isOpen={isOpen}
        onClose={onClose}
        hideHeader={true}
      >
        <div className='text-center'>
          <img className='mt-4 mb-4' src={CastleLogo}></img>
          <h5>Welcome to our new printing feature.</h5>
          <p className='mb-4'>It has been designed to help you save paper and give you flexibility with graphics, question layout, fonts, etc.
                    To learn more about how to make the best use of this feature, please see the
          <a className='text-blue' target="_blank" href={`${baseUrl}/Documents/Castle%20Learning_Assignment%20Printing%20FAQ.pdf`} rel="noreferrer"> FAQ & Tips </a> link to the right of the print icon.
          </p>
          <p>Please leave us feedback on this feature by clicking<br /> the <label className='text-blue text-decoration-underline cursor-pointer' onClick={()=>setOpenFeedbackModel(true)}>Feedback</label> link to the right of the print icon.
          </p>
          <input className='mx-2' value={hidePrintInfo} type='checkbox' onChange={(e) => updatePrintMessageAsync(e.target.checked)} /><span>Do not display this message again.</span><br />
          <button className='btn btn-castleRed mt-3' onClick={onClose}>Close</button>
        </div>
      </Modal>
      {openFeedbackModel && 
      <HelpRequest
        modalData={openFeedbackModel}
        setModalData={setOpenFeedbackModel}
        modalSubmissionType='feedback'
      />
      }
    </>

  );
};

AssignmentPrintMessage.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func
};

export default AssignmentPrintMessage;
